module.exports = __webpack_public_path__ + "static/media/uber-eats.b3cafe81.png";